import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FAQ from './FAQ';
import {
  makeSelectCollections,
  makeSelectPage,
  makeSelectTotalPage,
  makeSelectLoading,
  makeSelectCollectionsOfMonths,
} from './selectors';
import { changePage } from './actions';
import Pagination from './Pagination';
import HeroSlideShow from '../HeroSlideShow';
import IllustCollectionsBanner from '../../../static/images/collection-page/slideshow-illust_ac.jpg';
import CollectionItem from '~/components/CollectionItem';
import withI18next from '~/../hocs/_withI18next';
import Container from '~/components/Container';
import HeroBanner from '~/containers/HeroBanner';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
import CollectionBreadcrumb from '~/components/CollectionBreadcrumb';
import NextPageButtonCustom from '~/components/NextPageButtonCustom';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '~/containers/AuthProvider/selectors';
import { loadCollection } from '~/containers/CollectionPage/actions';
import { urls } from '~/utils';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import TagTrending from '~/components/TagTrending';
import LinkTo from '~/components/LinkTo';
import { makeSelectIsCountdownActive } from '~/containers/PaymentModal/selectors';
import BannerDiscount from '~/components/BannerDiscount';
import SEOTextSub from '~/components/SEOTextSub';

const roles = Config.getRoles();

@withI18next(['page-collections'])
class CollectionPage extends React.Component {
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.page !== this.props.page) {
  //     this.props.loadCollection({
  //       page: nextProps.page,
  //       lang: 'en',
  //       perpage: 21,
  //     });
  //   }
  // }
  renderOtherService = (data) => {
    const { t } = this.props;

    const key = Object.keys(data).filter((serviceType) => {
      return (
        serviceType !== 'collections' &&
        serviceType !== 'count_collections' &&
        serviceType !== 'totalpage'
      );
    });
    return key.map((serviceType, key) => {
      return (
        <Container key={key} className="collection-other-service">
          <div className="similar-collection-header">
            <p className="collection-similar-title">
              {t(
                `${Config.getPrefix(
                  serviceType,
                )}_explore_more_collections_from`,
              )}
            </p>
            <LinkTo
              label={t('view_all')}
              href="/collections"
              host={Config.getSiteURL(serviceType)}
            />
          </div>
          <div className="container-collections">
            {data[serviceType].map((data, idx) => {
              return (
                <CollectionItem
                  key={idx}
                  data={data}
                  t={t}
                  serviceType={serviceType}
                />
              );
            })}
          </div>
          <style>
            {`
              .ac-container.collection-other-service{
                background: ${themeVariables.color.white};
                padding-top: 32px;
                padding-bottom: 32px;
              }
              .container-collections {
                  display: grid;
                  grid-gap: 24px;
                  grid-template-columns: repeat(auto-fill, minmax(376px, 1fr));
                  margin-top:16px;
                }
              .collection-similar-title{
                  font-style: normal;
                  font-weight: 600;
                  font-size: 24px;
                  line-height: 28px;
                  color: #1b2833;
              }
              .similar-collection-header{
                  display:flex;
                  flex-direction:row;
                  justify-content:space-between;
              }
              .link-collection-similar {
                  font-style: normal;
                  font-weight: 600;
                  font-size: 16px;
                  line-height: 28px;
                  text-align: center;
                  text-decoration: none;
                  color: #509bdc;
                }
              .link-collection-similar:hover {
                text-decoration-line: underline !important;
                  color: #509bdc;
                  opacity:0.9;
              }
              @media(max-width:${themeVariables.breakpoints.tabletS.minWidth}px){
                .container-collections{
                  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                }
                .collection-similar-title{
                  font-size: 18px;
                }
              }
              `}
          </style>
        </Container>
      );
    });
  };

  renderCollectionOfMonths = (data) => {
    const { t } = this.props;
    return (
      <Container className="collection-of-month">
        <div className="similar-collection-header">
          <p className="collection-similar-title">
            {t('header_collection_of_months')}
          </p>
        </div>
        <div className="container-collections">
          {data.map((data, idx) => {
            return (
              <CollectionItem
                key={idx}
                data={data}
                t={t}
                // serviceType={serviceType}
              />
            );
          })}
        </div>
        <style>
          {`
              .collection-of-month{
                background: ${themeVariables.color.white};
                padding-top: 64px;
                padding-bottom: 0;
              }
              .container-collections {
                  display: grid;
                  grid-gap: 24px;
                  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
                }
              .collection-similar-title{
                  font-style: normal;
                  font-weight: 600;
                  font-size: 24px;
                  line-height: 28px;
                  color: #1b2833;
              }
              .similar-collection-header{
                  display:flex;
                  flex-direction:row;
                  justify-content:space-between;
              }
              .link-collection-similar {
                  color: ${themeVariables.colors.primary};
                  text-decoration-line: underline;
                }
              .link-collection-similar:hover {
              text-decoration-line: underline !important;
              color: ${themeVariables.colors.primary};
              }
              `}
        </style>
      </Container>
    );
  };

  onChangePage = (page) => {
    this.props.changePage(page);
  };
  onNextLink() {
    let currentPage = this.props.page;
    if (currentPage >= this.props.totalPage) {
      return {};
    }
    currentPage++;

    const query = { page: currentPage };

    const { ...beQueryStrings } = query;

    const path = urls.convertToQueryStrings(beQueryStrings);
    return {
      asPath: `/${this.props.lng}/collections/?${path}`,
      query: { page: currentPage },
    };
  }

  render() {
    const {
      t,
      lng,
      collections,
      totalPage,
      page,
      loading,
      collectionOfMonths,
      isAuthenticated,
      profile,
      isCountdownActive,
    } = this.props;
    const collectionData = collections.collections;

    const isDiscountDisplayed =
      profile.role !== roles.PREMIUM &&
      profile.role !== roles.CREATOR &&
      isCountdownActive;

    return (
      <div className="collection-page">
        {page == 1 && (
          <>
            {Config.isDesignAC() ? (
              <HeroSlideShow />
            ) : (
              <HeroBanner
                imageURL={
                  Config.isIllustAC()
                    ? IllustCollectionsBanner
                    : `${Config.staticPrefix}/static/images/collection-page/slideshow-${Config.serviceType}.png`
                }
                title={t(
                  Config.getPrefixContent('title_slide_show_collection'),
                )}
                subTitle={t(
                  Config.getPrefixContent('content_slide_show_collection'),
                )}
                hiddenExplore={true}
                responsive={true}
                altImage={
                  Config.isIllustAC() ? t('ill_alt_top_image') : undefined
                }
              />
            )}
            {isDiscountDisplayed && <BannerDiscount />}
          </>
        )}

        <Container style={{ paddingTop: 32 }}>
          <div className="header-content">
            <div className="breadcrumb">
              <CollectionBreadcrumb />
            </div>
            <div className="pagination">
              <Pagination
                currentPage={+page}
                totalPage={+totalPage}
                onChange={this.onChangePage}
                // query={query}
                path="/collections"
                asPath={'/collections'}
              />
            </div>
          </div>
        </Container>
        <Container
          style={{
            background: themeVariables.color.white,
            paddingTop: 16,
            paddingBottom: 32,
          }}
        >
          {!loading ? (
            <div className="container-collections">
              {collectionData &&
                collectionData.map((data, idx) => {
                  return <CollectionItem key={idx} data={data} t={t} />;
                })}
            </div>
          ) : (
            <LoadingSpinner />
          )}
        </Container>
        <Container style={{ background: '#fff', marginBottom: 64 }}>
          {page < totalPage && (
            <div className="bottom-pagination">
              <div className="next-page-bottom">
                <NextPageButtonCustom
                  pathname="/collections"
                  query={this.onNextLink().query}
                  as={this.onNextLink().asPath}
                  t={t}
                  type="next_page"
                  label={t('next_page')}
                />
              </div>
              <div className="pagination-bottom">
                <Pagination
                  currentPage={+page}
                  totalPage={+totalPage}
                  onChange={this.onChangePage}
                  //   query={query}
                  path="/collections"
                  asPath={'/collections'}
                />
              </div>
            </div>
          )}
        </Container>
        {page == 1 && (
          <Container className="collection-des-content">
            <div
              dangerouslySetInnerHTML={{
                __html: t(Config.getPrefixContent('des_content'), {
                  link: '/extra-license',
                }),
              }}
            ></div>
          </Container>
        )}
        {this.renderCollectionOfMonths(collectionOfMonths)}
        {/* <Container
          style={{
            background: themeVariables.color.white,
            paddingTop: 32,
            paddingBottom: 32,
          }}
        > */}
        {/* <p className="collection-months-title">Collection of months</p>
          <div className="container-collections">
            <CollectionItem />
            <CollectionItem />
            <CollectionItem />
          </div> */}
        {/* </Container> */}
        {/* <Trending /> */}
        <TagTrending />
        {this.renderOtherService(collections)}
        <FAQ t={t} lng={lng} />
        {!isAuthenticated && (Config.isIllustAC() || Config.isPhotoAC()) && (
          <SEOTextSub t={t} lng={lng} />
        )}
        {/* {isAuthenticated && <SEOTextACworks />} */}
        <style jsx>
          {`
            .breadcrumb {
              background-color: transparent;
              margin-bottom: 0px;
            }
            .collection-page {
              margin-bottom: 64px;
            }
            .collection-des-content {
              background: ${themeVariables.color.gray};
              padding-top: 32px;
              padding-bottom: 32px;
            }
            .container-collections {
              display: grid;
              grid-gap: 24px;
              grid-template-columns: repeat(auto-fill, minmax(376px, 1fr));
            }
            .header-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .bottom-pagination {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: space-between;
            }
            .collection-months-title {
              font-style: normal;
              font-weight: 600;
              font-size: 24px;
              line-height: 28px;
              color: #1b2833;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .header-content {
                flex-direction: column;
              }
              .pagination {
                display: flex;
                justify-content: flex-end;
                margin-top: 16px;
              }
              .bottom-pagination {
                flex-direction: column;
              }
              .next-page-bottom {
                display: flex;
                justify-content: flex-start;
                width: 100%;
              }
              .pagination-bottom {
                display: flex;
                justify-content: flex-end;
                width: 100%;
                margin-top: 16px;
              }
              .container-collections {
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .link-extra-license {
              // color: ${themeVariables.colors.primary};
              text-decoration-line: underline;
            }
            .link-extra-license:hover {
              text-decoration-line: underline !important;
              color: ${themeVariables.colors.link};
              opacity: 0.8;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  collections: makeSelectCollections(),
  collectionOfMonths: makeSelectCollectionsOfMonths(),
  profile: makeSelectProfile(),
  isAuthenticated: makeSelectIsAuthenticated(),
  totalPage: makeSelectTotalPage(),
  page: makeSelectPage(),
  loading: makeSelectLoading(),
  isCountdownActive: makeSelectIsCountdownActive(),
});
const mapDispatchToProps = (dispatch) => ({
  changePage: (value) => dispatch(changePage(value)),
  loadCollection: (query) => dispatch(loadCollection(query)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CollectionPage);
